var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPlayCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.03 17.75l.593-.593a1.26 1.26 0 011.784 0l2.96 2.96 8-8a.977.977 0 01.116-.097V3.417A3.416 3.416 0 0025.067 0H3.42A3.417 3.417 0 000 3.417v14.066A3.417 3.417 0 003.42 20.9h12.97l-1.36-1.36a1.257 1.257 0 010-1.79zm-3.667-2.083a.476.476 0 01-.477-.467V6.583a.474.474 0 01.247-.42.46.46 0 01.48 0l6.607 4.327a.479.479 0 010 .803l-6.603 4.31a.467.467 0 01-.254.074v-.01z",
    fill: "#5560FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.43 10.89a.474.474 0 00-.217-.4l-6.596-4.31a.46.46 0 00-.48 0 .473.473 0 00-.25.403V15.2a.477.477 0 00.246.42c.07.038.148.058.227.057.09 0 .178-.025.253-.074l6.607-4.31a.478.478 0 00.21-.403z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.74 12.72l-.594-.593a1.253 1.253 0 00-1.666-.097c-.041.03-.08.062-.117.097l-8 8-2.96-2.96a1.26 1.26 0 00-1.783 0l-.59.583a1.256 1.256 0 000 1.78l1.36 1.36 3.383 3.393a.835.835 0 001.187 0l9.78-9.783a1.258 1.258 0 000-1.78z",
    fill: "#FFD600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlayCheck);
export default __webpack_public_path__ + "static/media/Icon-play-check.dfa20704.svg";
export { ForwardRef as ReactComponent };